import { render, staticRenderFns } from "./chitiet.vue?vue&type=template&id=bc6d5a10&scoped=true"
import script from "./chitiet.vue?vue&type=script&lang=js"
export * from "./chitiet.vue?vue&type=script&lang=js"
import style0 from "./chitiet.vue?vue&type=style&index=0&id=bc6d5a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6d5a10",
  null
  
)

export default component.exports